import {
  GET_DETAIL_BS,
  GET_TREE_VIEW,
  GET_APQC_VER,
  GET_APQC_TEMPLATE,
  GET_APQC_LIB,
  GET_INDEX_VIEW_SEARCH,
  GET_HIERARCHY,
  GET_INDEX_VIEW,
  GET_LIST_PROCESS_LEVEL,
  UPDATE_LEVEL_PROCEESS_PARENT
} from "redux/actions/business_process";

const initialState = {
  business_process: [],
  hierarchy: [],
  treeview: [],
  business_process_search: [],
  apqc_ver: "",
  apqc_lib: [],
  apqc_template: [],
  detail: {},
  process_level: [],
  level: 1
};
// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initialState, { type, payload, update }) => {
  switch (type) {
    case GET_APQC_VER: {
      return {
        ...state,
        apqc_ver: payload
      };
    }
    case GET_APQC_LIB: {
      return {
        ...state,
        apqc_lib: payload
      };
    }
    case GET_APQC_TEMPLATE: {
      if (payload?.length === 0) {
        return {
          ...state,
          apqc_template: []
        };
      }
      return {
        ...state,
        apqc_template: payload
      };
    }
    case GET_INDEX_VIEW: {
      if (update) {
        const products = [...state.business_process];
        const index = products.findIndex(
          product => product.process_id === payload.process_id
        );
        state.business_process[index] = payload;

        return state;
      }
      return {
        ...state,
        business_process: payload
      };
    }
    case GET_INDEX_VIEW_SEARCH: {
      return {
        ...state,
        business_process_search: payload
      };
    }
    case GET_HIERARCHY: {
      return {
        ...state,
        hierarchy: payload.reverse()
      };
    }
    case GET_TREE_VIEW: {
      return {
        ...state,
        treeview: payload?.length === 0 ? [] : payload
      };
    }
    case GET_DETAIL_BS: {
      return {
        ...state,
        detail: payload
      };
    }
    case GET_LIST_PROCESS_LEVEL: {
      return {
        ...state,
        process_level: payload
      };
    }
    case UPDATE_LEVEL_PROCEESS_PARENT: {
      return {
        ...state,
        level: payload
      };
    }
    default:
      return state;
  }
};
